
import { mixins, Options } from "vue-class-component";
import Breadcrumbs from "@/components/ui/BaseBreadcrumbs/index.vue";
import {
  AlbumAndAssetManagementMixin,
  RoutingUtilityMixin,
  AssetDescriptionAccessMixin,
} from "@/mixins";
import { useMq } from "vue3-mq";

const ASSETS_ROUTE = "3d-viewer/albums/asset";

@Options({
  name: "HomeFooterToolsDesktop",
  components: { Breadcrumbs },
})
export default class HomeFooterToolsDesktop extends mixins(
  AlbumAndAssetManagementMixin,
  RoutingUtilityMixin,
  AssetDescriptionAccessMixin
) {
  private isLearnMoreActive = false;
  private mq = useMq();

  protected get isAssetsRoute(): boolean {
    return this.$route.name === ASSETS_ROUTE;
  }

  protected get getLearnMoreKey(): string {
    return this.isLearnMoreActive ? "close" : "learn_more";
  }

  protected get isDesktop(): boolean {
    return ["lg", "xl", "xxl"].includes(this.mq.current);
  }

  protected get isDescriptionDisabled(): boolean {
    const slug = this.$route.params.assetSlug as string;
    return this.isDescriptionDisabledForSlug(slug, this.isDesktop);
  }

  protected get learnMoreButtonClasses(): (string | Record<string, boolean>)[] {
    return [
      "btn",
      "btn--learn-more",
      {
        "is-active": this.isLearnMoreActive,
        "is-disabled": this.isDescriptionDisabled,
      },
    ];
  }

  protected toggleDescription(): void {
    if (this.isDescriptionDisabled) return;

    this.emitter.emit(
      "asset-description-toggle",
      (this.isLearnMoreActive = !this.isLearnMoreActive)
    );
  }

  mounted(): void {
    this.emitter.on("asset-description-toggle", (state: boolean) => {
      this.isLearnMoreActive = state;
    });
  }
}
